module.exports = __webpack_public_path__ + "img/manual2.679d01ef.jpg";